import React, { Dispatch, SetStateAction } from 'react'
import { Grid, Typography } from '@mui/material'
import equals from 'ramda/src/equals'

import { PricingTabKind } from '@ecm/pages/pricing'
import Color from '@ecm/ui/element/Color'

type PricingTabProps = {
  backgroundColor: string
  header: string
  kind: PricingTabKind
  onClick: () => void
  selectedTab: PricingTabKind
  subHeader: string
}

const PricingTab = ({
  backgroundColor,
  header,
  kind,
  selectedTab,
  onClick,
  subHeader,
}: PricingTabProps) => {
  return (
    <Grid
      container
      onClick={onClick}
      alignItems="center"
      direction="column"
      bgcolor={backgroundColor}
      sx={{
        cursor: kind !== selectedTab ? 'pointer' : 'default',
        margin: { md: '0 0.5em', xs: 0 },
        maxWidth: '700px',
        padding: '1em 0.75em',
        textAlign: 'center',
        width: { md: '45%', xs: '50%' },
      }}
    >
      <Typography variant="h5" component="h2" margin="0" color={Color.saint.darker}>
        {header}
      </Typography>
      <Typography
        variant="p3"
        margin="0"
        color={Color.saint.darker}
        display={{ sm: 'block', xs: 'none' }}
      >
        {subHeader}
      </Typography>
      <Typography
        variant="p4"
        margin="0"
        color={Color.saint.darker}
        display={{ sm: 'none', xs: 'block' }}
      >
        {subHeader}
      </Typography>
    </Grid>
  )
}

const PlansTabsBlock = ({
  selectedTab,
  setSelectedTab,
}: {
  selectedTab: PricingTabKind
  setSelectedTab: Dispatch<SetStateAction<PricingTabKind>>
}) => {
  const isActiveTab = equals(selectedTab)

  return (
    <Grid container justifyContent="center" margin="0" padding="0" bgcolor={Color.smoke.normal}>
      <PricingTab
        backgroundColor={isActiveTab('mailbox') ? Color.white.normal : Color.smoke.darker}
        header="MailBox Plans"
        kind="mailbox"
        onClick={() => setSelectedTab('mailbox')}
        selectedTab={selectedTab}
        subHeader="For individuals and smaller organizations"
      />

      <PricingTab
        backgroundColor={isActiveTab('mailroom') ? Color.white.normal : Color.smoke.darker}
        header="MailRoom Plans"
        kind="mailroom"
        onClick={() => {
          setSelectedTab('mailroom')
        }}
        selectedTab={selectedTab}
        subHeader="For larger businesses and enterprises"
      />
    </Grid>
  )
}

export default PlansTabsBlock
